// extracted by mini-css-extract-plugin
module.exports = {"evento":"Evento_evento___4otW","opcoes":"Evento_opcoes__3mc0V"};